export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/PaymentLinkUsed.3bc934f8.svg","height":101,"width":101,"blurWidth":0,"blurHeight":0};